<template>
    <v-card-text class="pa-6">

        <div class="section-container">
            <div class="section-header mb-4">
                <v-icon color="primary" size="20">mdi-domain</v-icon>
                <h3 class="section-title">Informazioni Aziendali</h3>
            </div>

            <v-alert type="info" variant="tonal" class="mb-6" density="compact">
                I dati aziendali non possono essere modificati autonomamente. Per modifiche contatta l'assistenza.
            </v-alert>

            <v-row>
                <v-col cols="12" md="6">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-office-building</v-icon>
                            <span>Ragione Sociale</span>
                        </div>
                        <div class="info-value">{{ azienda.ragioneSociale || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="12" md="6">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon>
                            <span>Partita IVA</span>
                        </div>
                        <div class="info-value">{{ azienda.pIva || '-' }}</div>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="4">
                    <div class="info-field">
                        <div class="info-label">
                            <v-icon size="18" color="grey-darken-1">mdi-map-marker-outline</v-icon>
                            <span>Indirizzo</span>
                        </div>
                        <div class="info-value">{{ azienda.indirizzo || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="12" md="4">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon> -->
                            <span>Città</span>
                        </div>
                        <div class="info-value">{{ azienda.citta || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="6" md="2">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-office-building</v-icon> -->
                            <span>CAP</span>
                        </div>
                        <div class="info-value">{{ azienda.cap || '-' }}</div>
                    </div>
                </v-col>

                <v-col cols="6" md="2">
                    <div class="info-field">
                        <div class="info-label">
                            <!-- <v-icon size="18" color="grey-darken-1">mdi-card-account-details</v-icon> -->
                            <span>Provincia</span>
                        </div>
                        <div class="info-value">{{ azienda.provincia || '-' }}</div>
                    </div>
                </v-col>
            </v-row>

            <!-- Card alternative style -->
            <!-- <v-row class="mt-4">
                <v-col cols="12" md="6">
                    <v-card variant="outlined" class="info-card">
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2">mdi-office-building-outline</v-icon>
                                <span class="text-caption text-grey-darken-1">Ragione Sociale</span>
                            </div>
                            <div class="text-h6">{{ azienda.ragioneSociale || 'Non specificata' }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card variant="outlined" class="info-card">
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2">mdi-identifier</v-icon>
                                <span class="text-caption text-grey-darken-1">Partita IVA</span>
                            </div>
                            <div class="text-h6">{{ azienda.pIva || 'Non specificata' }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row> -->

        </div>

    </v-card-text>
</template>

<script>
export default {
    name: "TabAzienda",

    props: {
        azienda: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.section-container {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 20px;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.info-field {
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
}

.info-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #757575;
    margin-bottom: 8px;
    text-transform: uppercase;
    font-weight: 500;
}

.info-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.info-card {
    height: 100%;
    transition: all 0.2s;
}

.info-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>